import React, { useEffect, useMemo } from "react";
import {
  Box,
  CircularProgress,
  Grid,
  Card,
  CardContent,
  Typography,
  Chip,
  Button,
  Pagination,
} from "@mui/material";
import GroupIcon from "@mui/icons-material/Group";
import { useLazyGetAdminExamsQuery } from "@/store/api/adminApi";

const ExamList = ({
  examsLoading,
  // filteredExams,
  examsData,
  getExamAssignmentCount,
  handleOpenAssignmentDialog,
  onPageChange,
}) => {
  const [page, setPage] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(9);
  // const [getExams, { data: examsData, isLoading: examsLoading }] = useLazyGetAdminExamsQuery();

  useEffect(() => {
    onPageChange?.(page);
  }, [page]);

  const exams = useMemo(() => examsData?.data || [], [examsData]);
  const pagination = useMemo(() => examsData?.pagination || {}, [examsData]);

  return examsLoading ? (
    <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
      <CircularProgress />
    </Box>
  ) : (
    <Grid container spacing={2}>
      {exams.map((exam) => (
        <Grid item xs={12} md={6} lg={4} key={exam._id}>
          <Card
            sx={{
              borderRadius: 2,
              border: "1px solid rgba(0,0,0,0.08)",
              "&:hover": {
                transform: "translateY(-2px)",
                boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
              },
              transition: "all 0.3s ease",
            }}
          >
            <CardContent>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "start",
                  mb: 2,
                }}
              >
                <Typography variant="h6" fontWeight="600" sx={{ flex: 1 }}>
                  {exam.title}
                </Typography>
                {/* <Chip
                  label={`${getExamAssignmentCount(exam._id)} assigned`}
                  size="small"
                  sx={{
                    bgcolor: "#e3f2fd",
                    color: "#1976d2",
                    fontWeight: 600,
                  }}
                /> */}
              </Box>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                {exam.description}
              </Typography>
              <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mb: 2 }}>
                <Chip label="RC - LC" size="small" variant="outlined" />
                <Chip
                  label={`${exam.totalQuestions} questions`}
                  size="small"
                  variant="outlined"
                />
              </Box>
              <Button
                fullWidth
                variant="contained"
                startIcon={<GroupIcon />}
                onClick={() => handleOpenAssignmentDialog(exam)}
                sx={{
                  background:
                    "linear-gradient(135deg, #4CAF50 0%, #45a049 100%)",
                  borderRadius: 2,
                  textTransform: "none",
                  fontWeight: 600,
                }}
              >
                Manage Assignments
              </Button>
            </CardContent>
          </Card>
        </Grid>
      ))}
      <Pagination
        sx={{ mt: 2, justifyItems: "center", width: "100%" }}
        count={pagination.totalPages}
        page={page}
        onChange={(e, value) => setPage(value)}
        variant="outlined"
        color="primary"
      />
    </Grid>
  );
};

export default ExamList;
